import React, { Component } from 'react';
import Table from '../../Table/Table';
import {
    fetchUrl,
    getUsers as fetchUsers
} from '../../UserManagement/userManagementActions';
import ListItem from './ListItem/ListItem';
import { connect } from 'react-redux';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import { roleShape } from '../../../utils/propTypes';
import _ from 'lodash';
import { getPaymentRouting as getPaymentRoutingFetch } from '../../PaymentRouting/paymentRoutingActions.js';
import {
    getPaymentRouting,
    getIsPaymentRoutingLoading,
    getPaymentRoutingErrorMessage,
    getCount,
    getPages, getIsPaymentRoutingLoaded
} from '../paymentRoutingEntity';
import {
    getUsers,
    getIsUsersLoading,
    getUsersErrorMessage
} from '../../UserManagement/userManagementEntity';
import { toggleModal } from '../../Modal/modalActions';
import { goToUrl } from '../../Table/tableActions';
import { getMerchants } from '../../MerchantManagement/merchantManagementEntity';

export function selectUser(history, user, newTab) {
    goToUrl(history, `/routingRules/${btoa(user.userName)}`, newTab);
}

export class Users extends Component {
    static propTypes = {
        isPaymentRoutingLoaded: PropTypes.bool,
        isPaymentRoutingLoading: PropTypes.bool,
        rules: PropTypes.array,
        roles: PropTypes.arrayOf(roleShape),
        paymentMerchants: PropTypes.array
    };

    constructor(props) {
        super(props);

        this.state = {
            needsRefetch: false
        };

        this.defaultColumnsAndProps = [
            {
                accessor: 'userName',
                defaultSortDesc: true,
                label: 'User E-mail',
                className: ['cursor-pointer'],
                minWidth: 150,
                show: true,
                sortable: true
            },
            {
                accessor: 'merchantIds',
                Cell: (props) => (props.original.merchantIds.join(', ')),
                filterable: false,
                label: 'Merchants',
                className: ['cursor-pointer'],
                minWidth: 300,
                show: true,
                sortable: false
            },
            {
                accessor: 'ruleTypes',
                filterable: false,
                label: 'Routing Rule Type',
                className: ['cursor-pointer'],
                minWidth: 175,
                show: true,
                sortable: false
            }
        ];
    }

    componentDidMount() {
        //check if merchants are loading, if not, load merchants
        this.props.onGetUsers();
    }

    componentDidUpdate(previousProps) {
        if (doesPropExistAndHasItChanged(previousProps, this.props, 'isCreateUserSuccessful')
            || doesPropExistAndHasItChanged(previousProps, this.props, 'isEditUserSuccessful')) {
            this.refetchData();
        }
    }

    getRuleTypes(originalRules) {
        let rules = _.uniq(_.reduce(originalRules, (ruleTypes, rule) => {
            ruleTypes.push(_.startCase(_.toLower(rule.ruleType)));

            return ruleTypes;
        }, []));

        return rules.join(', ') || 'None';
    }

    getMerchantIds(originalUserName) {
        let merchantIds = _.get(_.find(this.props.users, (user) => {
            return user.userName === originalUserName;
        }), 'accessRights.merchantIds');

        return Object.keys(merchantIds || {});
    }

    resetNeedsRefetch = () => {
        this.setState({ needsRefetch: false });
    };

    refetchData = () => {
        this.setState({ needsRefetch: true });
    };

    getIsUsersRulesTableLoading = () => {
        return getIsPaymentRoutingLoading() || getIsUsersLoading();
    };

    getUsersRulesErrorMessage = () => {
        return getUsersErrorMessage() + getPaymentRoutingErrorMessage();
    };

    getPaymentRouting = (reduxState) => {
        let tableData = getPaymentRouting(reduxState);

        if (_.isEmpty(this.props.paymentMerchants)) {
            return [];
        }

        tableData = _.map(tableData, (user) => {
            return {
                merchantIds: this.getMerchantIds(user.userName),
                userName: user.userName,
                ruleTypes: this.getRuleTypes(user.rules),
                rules: user.rules
            };
        });

        return tableData;
    };

    render() {
        const shouldShowLoader = !this.props.isPaymentRoutingLoaded || this.props.isUsersLoading;

        return (
            <Table
                fetchUrl={fetchUrl}
                className="emvio-users-table"
                defaultColumnsAndProps={this.defaultColumnsAndProps}
                defaultSorted={[{
                    desc: false,
                    id: 'userName'
                }]}
                fetchData={getPaymentRoutingFetch}
                filterable={true}
                countSelector={getCount}
                dataSelector={this.getPaymentRouting}
                errorMessageSelector={getPaymentRoutingErrorMessage}
                isActionLoading={shouldShowLoader}
                isDataLoadingSelector={this.getIsUsersRulesTableLoading}
                pagesSelector={getPages}
                itemKey="userName"
                ListItemComponent={ListItem}
                needsRefetch={this.state.needsRefetch}
                noDataText="No Users with Payment Configurations Found"
                resetNeedsRefetch={this.resetNeedsRefetch}
                selectRow={selectUser}
                shouldAddColumnDialog={false}
                shouldHideCardPadding
                shouldHideDateRange
                shouldHideExport
                uniqueTableName="UsersAndRules"
            />
        );
    }
}

export function mapStateToProps(state) {
    return {
        isUsersLoading: getIsUsersLoading(state),
        isPaymentRoutingLoaded: getIsPaymentRoutingLoaded(state),
        isPaymentRoutingLoading: getIsPaymentRoutingLoading(state),
        usersPaymentRules: getPaymentRouting(state),
        users: getUsers(state),
        paymentMerchants: getMerchants(state)
    };
}

// fetching merchants now so they are ready when the modal loads
export function mapDispatchToProps(dispatch) {
    return {
        onGetUsers: () => dispatch(fetchUsers({}, 0, 100)),
        onEditRule: (user) => () => {
            dispatch(toggleModal('editRule', user));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);
